export function isNotNull<T>(value: T | null): value is T {
  return value !== null;
}

export const isNull = <T>(value: T | null): value is null => value === null;
